/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import omit from "lodash/fp/omit";

import ApiCaller from "~/api/ApiCaller";
import {
  PostCreateResellerRequestBody,
  PostCreateResellerResponse,
  PostResendVerifyEmailPayload,
  PostResendVerifyEmailResponseData,
  PostVerifyPayload,
  PostVerifyResponseData,
} from "~/features/signup/types";

const SignupApi = {
  postCreateReseller: (payload: PostCreateResellerRequestBody) => {
    const url = "/v1/signup/createreseller";

    return ApiCaller.post<PostCreateResellerResponse>(url, omit("recaptchaToken", payload), {
      headers: { ["x-recaptcha-token"]: payload.recaptchaToken },
    });
  },
  postVerifyEmail: (payload: PostVerifyPayload) =>
    ApiCaller.post<PostVerifyResponseData>("/v1/signup/verifyemail", payload),
  postResendVerifyEmail: (payload: PostResendVerifyEmailPayload) =>
    ApiCaller.post<PostResendVerifyEmailResponseData>("/v1/signup/resendverifyemail", payload),
};

export default SignupApi;
